import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from '../alertas/alertas.component';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-usersandpermissions',
  templateUrl: './usersandpermissions.component.html',
  styleUrls: ['./usersandpermissions.component.sass']
})
export class UsersAndPermissionsComponent implements OnInit {
  public tabActive = 'Manejo de Cuenta';
  public adminUsers;
  public idUser:number;
  public idUserAPP:number;
  public idParent:string;
  constructor(private global:GlobalService,public dialog:MatDialog,private services: Service,private loadingScreenService :LoadingScreenService,private router:Router,public AngularFireAnalytics:AngularFireAnalytics){
    this.AngularFireAnalytics.setCurrentScreen("Usuarios y Permisos");
  }   
  ngOnInit(){
    this.global.validateSession();
    this.loadingScreenService.startLoading();
    this.idUser=parseInt(sessionStorage.getItem("idUser"));
    this.idUserAPP=parseInt(sessionStorage.getItem("idUserAPP"));
    this.idParent=sessionStorage.getItem("idParent");
    this.services.userList(this.idUser,this.idParent).subscribe(data =>{
      this.loadingScreenService.stopLoading();
      this.adminUsers = data;
    });
    
  }
  add() {
    sessionStorage.setItem("tunnel",null);
    this.router.navigate(['userspermissions']);
  }
  delete(idUserFk,idUser,parent,name,lastname){
    if(idUser!=parent){
      if(this.idUserAPP!=idUser){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true
        dialogConfig.data = {message:'¿Estás seguro que desea eliminar usuario: '+name +' '+lastname+' ?',btmConfirm:true};
        const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);   
        dialogRef.afterClosed().subscribe(value => {
          if(value=='continue'){
            this.loadingScreenService.startLoading();
            this.services.delete(idUserFk,idUser,parent,sessionStorage.getItem("token")).subscribe(data =>{
              if(data.hasError==false){
                this.services.userList(this.idUser,this.idParent).subscribe(data2 =>{
                  this.loadingScreenService.stopLoading();
                  this.adminUsers = data2;
                  this.global.notif(data.errorDesc);
                });
              }
              else{
                this.loadingScreenService.stopLoading();
                this.global.notif(data.errorDesc);
              }
            });
          }   
        });
      }
      else{
        this.global.notif("No se permite eliminar al usuario con esta cuenta.");
      }
    }
    else{
      this.global.notif("No se permite eliminar al creador de la cuenta.");
    }
  }
  edit(name,lastname,email,role,phoneNumber,id) {
    let datos={
      id:id,
      name:name,
      lastname:lastname,
      email:email,
      role:role,
      phone:phoneNumber
    }
    sessionStorage.setItem("tunnel",btoa(JSON.stringify(datos)));
    this.router.navigate(['userspermissions']);
  }
  isOdd(num) { 
    return num % 2;
  }
}
